<template>
  <el-dialog title="Fusion de deux fiches" :visible.sync="visible" :close-on-click-modal="false" v-if="from">
    <el-button style="position: absolute; top: 20px; right: 50px;" class="m-b-20" type="default" size="mini" v-on:click="invert()">
      <i class="fa fa-arrow-left" aria-hidden="true"></i> Inverser la fusion <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </el-button>

    <table class="table table-sm">
      <thead>
      <tr>
        <th></th>
        <th>Source</th>
        <th>Destination</th>
        <th>Fusionné</th>
      </tr>
      </thead>
      <tbody>
      <tr :class="lineClass(from.name, into.name)">
        <th>Nom :</th>
        <td :class="itemClass('from', from.name, into.name)">{{ from.name }}</td>
        <td :class="itemClass('into', from.name, into.name)">{{ into.name }}</td>
        <td>{{ keep(from.name, into.name) }}</td>
      </tr>
      <tr :class="lineClass(from.siret, into.siret)">
        <th>Siret :</th>
        <td :class="itemClass('from', from.siret, into.siret)">{{ from.siret }}</td>
        <td :class="itemClass('into', from.siret, into.siret)">{{ into.siret }}</td>
        <td>{{ keep(from.siret, into.siret) }}</td>
      </tr>
      <tr :class="lineClass(from.job, into.job)">
        <th>Métier :</th>
        <td :class="itemClass('from', from.job, into.job)">{{ from.job }}</td>
        <td :class="itemClass('into', from.job, into.job)">{{ into.job }}</td>
        <td>{{ keep(from.job, into.job) }}</td>
      </tr>
      <tr :class="lineClass(from.address.street, into.address.street)">
        <th>Adresse :</th>
        <td :class="itemClass('from', from.address.street, into.address.street)">{{ from.address.street }}</td>
        <td :class="itemClass('into', from.address.street, into.address.street)">{{ into.address.street }}</td>
        <td>{{ keep(from.address.street, into.address.street) }}</td>
      </tr>
      <tr :class="lineClass(from.address.street_complement, into.address.street_complement)">
        <th>Complément d'adresse :</th>
        <td :class="itemClass('from', from.address.street_complement, into.address.street_complement)">
          {{ from.address.street_complement }}
        </td>
        <td :class="itemClass('into', from.address.street_complement, into.address.street_complement)">
          {{ into.address.street_complement }}
        </td>
        <td>{{ keep(from.address.street_complement, into.address.street_complement) }}</td>
      </tr>
      <tr :class="lineClass(from.address.zip_code, into.address.zip_code)">
        <th>Code postal :</th>
        <td :class="itemClass('from', from.address.zip_code, into.address.zip_code)">{{ from.address.zip_code }}</td>
        <td :class="itemClass('into', from.address.zip_code, into.address.zip_code)">{{ into.address.zip_code }}</td>
        <td>{{ keep(from.address.zip_code, into.address.zip_code) }}</td>
      </tr>
      <tr :class="lineClass(from.address.city, into.address.city)">
        <th>Ville :</th>
        <td :class="itemClass('from', from.address.city, into.address.city)">{{ from.address.city }}</td>
        <td :class="itemClass('into', from.address.city, into.address.city)">{{ into.address.city }}</td>
        <td>{{ keep(from.address.city, into.address.city) }}</td>
      </tr>
      <tr :class="lineClass(from.public.name, into.public.name)">
        <th>Nom public :</th>
        <td :class="itemClass('from', from.public.name, into.public.name)">{{ from.public.name }}</td>
        <td :class="itemClass('into', from.public.name, into.public.name)">{{ into.public.name }}</td>
        <td>{{ keep(from.public.name, into.public.name) }}</td>
      </tr>
      <tr :class="lineClass(from.public.street, into.public.street)">
        <th>Adresse publique :</th>
        <td :class="itemClass('from', from.public.street, into.public.street)">{{ from.public.street }}</td>
        <td :class="itemClass('into', from.public.street, into.public.street)">{{ into.public.street }}</td>
        <td>{{ keep(from.public.street, into.public.street) }}</td>
      </tr>
      <tr :class="lineClass(from.public.street_complement, into.public.street_complement)">
        <th>Complément d'adresse publique :</th>
        <td :class="itemClass('from', from.public.street_complement, into.public.street_complement)">
          {{ from.public.street_complement }}
        </td>
        <td :class="itemClass('into', from.public.street_complement, into.public.street_complement)">
          {{ into.public.street_complement }}
        </td>
        <td>{{ keep(from.public.street_complement, into.public.street_complement) }}</td>
      </tr>
      <tr :class="lineClass(from.public.zip_code, into.public.zip_code)">
        <th>Code postal publique :</th>
        <td :class="itemClass('from', from.public.zip_code, into.public.zip_code)">{{ from.public.zip_code }}</td>
        <td :class="itemClass('into', from.public.zip_code, into.public.zip_code)">{{ into.public.zip_code }}</td>
        <td>{{ keep(from.public.zip_code, into.public.zip_code) }}</td>
      </tr>
      <tr :class="lineClass(from.public.city, into.public.city)">
        <th>Ville publique :</th>
        <td :class="itemClass('from', from.public.city, into.public.city)">{{ from.public.city }}</td>
        <td :class="itemClass('into', from.public.city, into.public.city)">{{ into.public.city }}</td>
        <td>{{ keep(from.public.city, into.public.city) }}</td>
      </tr>
      </tbody>
    </table>

    <div style="text-align: center">
      <p class="text-muted m-b-20" style="width: 75%; margin: auto;">
        Attention, la fusion écrasera les données ci-dessus, et déplacera tous les rappels, commentaires, appels,
        services, propals etc ... de l'ancienne fiche vers la nouvelle.</p>

      <el-button type="warning" v-on:click="merge()" :loading="button.loading">{{ button.text }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Customer from '../Entities/Customer.vue'

  export default {
    components: {
      Customer
    },
    name: 'merge-customers-modal',
    data () {
      return {
        visible: false,
        from: null,
        into: null,
        button: {
          loading: false,
          text: 'Fusionner'
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this
      this.$model.customer.on('merge', ({from, into}) => {
        self.visible = true
        self.from = from
        self.into = into
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
      },
      close () {
        this.visible = false
      },
      invert () {
        let from = this.from
        let into = this.into

        this.from = into
        this.into = from

        this.$forceUpdate()
      },
      merge () {
        let self = this

        self.button.loading = true
        self.button.text = 'Fusion des fiches ...'

        this.$nexus.post('crm2', 'customers/merge', {
          from: self.from.id,
          into: self.into.id
        }).then(() => {
          self.button.loading = false
          self.button.text = 'Fusionner'
          self.visible = false
          self.$router.push('/customers/' + self.into.id)
          self.$message.success('Fiches fusionnées avec succès.')
        }).catch((err) => {
          self.$message.error('Erreur de fusion : ' + err)
        })
      },
      keep (fromValue, intoValue) {
        if (!intoValue || intoValue.length === 0) {
          return fromValue
        } else {
          return intoValue
        }
      },
      itemClass (type, fromValue, intoValue) {
        if (!intoValue || intoValue.length === 0) {
          return type === 'from' ? 'kept' : 'deleted'
        } else {
          return type === 'from' ? 'deleted' : 'kept'
        }
      },
      lineClass (fromValue, intoValue) {
        if (!fromValue || fromValue.length === 0) {
          return ''
        } else {
          if (!intoValue || intoValue.length === 0) {
            return 'table-success'
          } else {
            return 'table-warning'
          }
        }
      }
    }
  }
</script>

<style scoped>
  .deleted {
    text-decoration: line-through;
    color: #ff5d48;
  }

  .kept {
    color: #1bb99a;
  }
</style>



// WEBPACK FOOTER //
// MergeCustomersModal.vue?ebb54d9a